export const landingPageContent = {
    en: {
      nav: {
        home: "Home",
        features: "Features",
        solutions: "Solutions",
        about: "About"
      },
      hero: {
        badge: "On-Premise GPT Platform",
        title: "Your Own GPT with LLM + RAG on Your Hardware",
        subtitle: "Deploy a complete on-premise GPT system with LLM and RAG capabilities running on your own infrastructure. Full data sovereignty with enterprise-grade AI capabilities. Agentic features coming soon.",
        primaryCta: "Get Started",
        features: [
          "LLM + RAG Powered",
          "On-Premise GPT",
          "Your Hardware, Your Data"
        ]
      },
      features: {
        title: "On-Premise GPT with LLM + RAG",
        subtitle: "Enterprise AI platform running on your hardware with complete data control",
        items: [
          {
            iconName: 'brainCircuit',
            title: "LLM + RAG Powered",
            description: "Full-featured GPT system with Large Language Models and Retrieval-Augmented Generation. Query your documents and knowledge base with AI-powered search and generation."
          },
          {
            iconName: 'lock',
            title: "On-Premise GPT",
            description: "Your own GPT system running entirely on your hardware. Complete data sovereignty with no data leaving your infrastructure. Deploy on single nodes or scale to cloud."
          },
          {
            iconName: 'database',
            title: "RAG Knowledge Base",
            description: "Build and query your own knowledge base with RAG. Upload documents, index your data, and get AI-powered answers from your private knowledge repository."
          },
          {
            iconName: 'cpu',
            title: "Your Hardware, Your Control",
            description: "Deploy on any GPU infrastructure - NVIDIA, AMD, Intel. From single node to unlimited cloud scale. Complete control over your hardware and data."
          },
          {
            iconName: 'zap',
            title: "Out-of-the-Box Deployment",
            description: "Deploy your on-premise GPT system in minutes. Pre-configured LLM and RAG capabilities ready to use on your infrastructure."
          },
          {
            iconName: 'bot',
            title: "Agentic Features Coming Soon",
            description: "Advanced agentic capabilities and multi-agent orchestration coming in future updates. Build autonomous AI agents on your infrastructure."
          }
        ]
      },
      solutions: {
        title: "Deploy Your On-Premise GPT System",
        subtitle: "LLM + RAG powered AI platform for Enterprises, Universities, and Public Agencies",
        cards: [
          {
            title: "Enterprises",
            description: "Deploy your own GPT system with LLM and RAG on your hardware. Complete data sovereignty with enterprise-grade AI capabilities.",
            benefits: [
              "On-premise GPT with LLM + RAG",
              "Query your private knowledge base",
              "Complete data sovereignty",
              "Agentic features coming soon"
            ]
          },
          {
            title: "Universities & Research",
            description: "Run LLM and RAG workloads on your GPU infrastructure. Build and query research knowledge bases with AI.",
            benefits: [
              "LLM + RAG on your hardware",
              "Research knowledge base queries",
              "GPU vendor flexibility",
              "Single node to cloud scaling"
            ]
          },
          {
            title: "Public Agencies",
            description: "Deploy compliant on-premise GPT with RAG for government use cases. All data stays on your infrastructure.",
            benefits: [
              "On-premise GPT deployment",
              "RAG-powered document queries",
              "Regulatory compliance built-in",
              "Complete data control"
            ]
          },
          {
            title: "Cloud Service Providers",
            description: "Offer on-premise GPT-as-a-Service to your customers with LLM + RAG capabilities on their infrastructure",
            benefits: [
              "LLM + RAG platform",
              "Multi-tenant resource isolation",
              "White-label customization",
              "Agentic features roadmap"
            ]
          }
        ]
      },
      auth: {
        login: "Login",
        signup: "Get Started"
      },
      footer: {
        company: {
          title: "Company",
          links: [
            "About Us"
          ]
        },
        solutions: {
          title: "Solutions",
          links: [
            "For Government",
            "For Enterprises",
            "For AI Infrastructure Operators"
          ]
        },
        resources: {
          title: "Resources",
          links: [
            "Documentation",
            "API Reference",
            "Support"
          ]
        },
        legal: {
          title: "Legal",
          links: [
            "Privacy Policy"
          ]
        }
      }
    },
    de: {
      nav: {
        home: "Startseite",
        features: "Features",
        solutions: "Lösungen",
        about: "Über uns"
      },
      hero: {
        badge: "On-Premise GPT Plattform",
        title: "Ihr eigenes GPT mit LLM + RAG auf Ihrer Hardware",
        subtitle: "Stellen Sie ein vollständiges On-Premise GPT-System mit LLM- und RAG-Funktionen bereit, das auf Ihrer eigenen Infrastruktur läuft. Vollständige Datensouveränität mit Enterprise-Grade KI-Funktionen. Agentische Features kommen bald.",
        primaryCta: "Jetzt starten",
        features: [
          "LLM + RAG Powered",
          "On-Premise GPT",
          "Ihre Hardware, Ihre Daten"
        ]
      },
      features: {
        title: "On-Premise GPT mit LLM + RAG",
        subtitle: "Enterprise KI-Plattform auf Ihrer Hardware mit vollständiger Datenkontrolle",
        items: [
          {
            iconName: 'brainCircuit',
            title: "LLM + RAG Powered",
            description: "Vollständiges GPT-System mit Large Language Models und Retrieval-Augmented Generation. Durchsuchen Sie Ihre Dokumente und Wissensdatenbank mit KI-gestützter Suche und Generierung."
          },
          {
            iconName: 'lock',
            title: "On-Premise GPT",
            description: "Ihr eigenes GPT-System, das vollständig auf Ihrer Hardware läuft. Vollständige Datensouveränität ohne Datenverlust. Bereitstellung auf einzelnen Knoten oder Skalierung bis zur Cloud."
          },
          {
            iconName: 'database',
            title: "RAG Wissensdatenbank",
            description: "Erstellen und durchsuchen Sie Ihre eigene Wissensdatenbank mit RAG. Laden Sie Dokumente hoch, indizieren Sie Ihre Daten und erhalten Sie KI-gestützte Antworten aus Ihrem privaten Wissensrepository."
          },
          {
            iconName: 'cpu',
            title: "Ihre Hardware, Ihre Kontrolle",
            description: "Bereitstellung auf jeder GPU-Infrastruktur - NVIDIA, AMD, Intel. Vom einzelnen Knoten bis zur unbegrenzten Cloud-Skalierung. Vollständige Kontrolle über Ihre Hardware und Daten."
          },
          {
            iconName: 'zap',
            title: "Out-of-the-Box Bereitstellung",
            description: "Stellen Sie Ihr On-Premise GPT-System in Minuten bereit. Vorkonfigurierte LLM- und RAG-Funktionen, die sofort auf Ihrer Infrastruktur einsatzbereit sind."
          },
          {
            iconName: 'bot',
            title: "Agentische Features kommen bald",
            description: "Erweiterte agentische Funktionen und Multi-Agent-Orchestrierung kommen in zukünftigen Updates. Erstellen Sie autonome KI-Agenten auf Ihrer Infrastruktur."
          }
        ]
      },
      solutions: {
        title: "Stellen Sie Ihr On-Premise GPT-System bereit",
        subtitle: "LLM + RAG powered KI-Plattform für Unternehmen, Universitäten und öffentliche Behörden",
        cards: [
          {
            title: "Unternehmen",
            description: "Stellen Sie Ihr eigenes GPT-System mit LLM und RAG auf Ihrer Hardware bereit. Vollständige Datensouveränität mit Enterprise-Grade KI-Funktionen.",
            benefits: [
              "On-Premise GPT mit LLM + RAG",
              "Abfragen Sie Ihre private Wissensdatenbank",
              "Vollständige Datensouveränität",
              "Agentische Features kommen bald"
            ]
          },
          {
            title: "Universitäten & Forschung",
            description: "Führen Sie LLM- und RAG-Workloads auf Ihrer GPU-Infrastruktur aus. Erstellen und durchsuchen Sie Forschungs-Wissensdatenbanken mit KI.",
            benefits: [
              "LLM + RAG auf Ihrer Hardware",
              "Forschungs-Wissensdatenbank-Abfragen",
              "GPU-Anbieter-Flexibilität",
              "Skalierung vom einzelnen Knoten bis zur Cloud"
            ]
          },
          {
            title: "Öffentliche Behörden",
            description: "Stellen Sie konformes On-Premise GPT mit RAG für Regierungs-Anwendungsfälle bereit. Alle Daten bleiben auf Ihrer Infrastruktur.",
            benefits: [
              "On-Premise GPT-Bereitstellung",
              "RAG-gestützte Dokumentenabfragen",
              "Regulatorische Compliance eingebaut",
              "Vollständige Datenkontrolle"
            ]
          },
          {
            title: "Cloud Service Provider",
            description: "Bieten Sie On-Premise GPT-as-a-Service für Ihre Kunden mit LLM + RAG-Funktionen auf deren Infrastruktur an",
            benefits: [
              "LLM + RAG Plattform",
              "Multi-Tenant Ressourcen-Isolation",
              "White-Label Anpassung",
              "Agentische Features Roadmap"
            ]
          }
        ]
      },
      auth: {
        login: "Anmelden",
        signup: "Jetzt starten"
      },
      footer: {
        company: {
          title: "Unternehmen",
          links: [
            "Über uns"
          ]
        },
        solutions: {
          title: "Lösungen",
          links: [
            "Für Behörden",
            "Für Unternehmen",
            "Für KI-Infrastrukturbetreiber"
          ]
        },
        resources: {
          title: "Ressourcen",
          links: [
            "Dokumentation",
            "API-Referenz",
            "Support"
          ]
        },
        legal: {
          title: "Rechtliches",
          links: [
            "Datenschutz"
          ]
        }
      }
    }
  };
